module.exports = __webpack_public_path__ + "static/img/111.6a1c47d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/111.jpg
// module id = HccB
// module chunks = 2